import axios from "axios";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState, useEffect } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../shared/ConfirmationModal"; 
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";

const AddCategory = () => {
  // const [setErr] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  // const [categoryAdded, setCategoryAdded] = useState(false);
    const[showmodal,setShowModal] = useState("");
     const [showModalmessage, setShowModalmessage] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false); // For error modal
  const [successMessage, setSuccessMessage] = useState(""); // Success message state
  const [failureMessage, setFailureMessage] = useState(""); // Failure message state
const [formValues, setFormValues] = useState(null); // State to store form values for confirmation
  const [industries, setIndustries] = useState([]);
  const [filteredIndustries, setFilteredIndustries] = useState([]);
  const [selectedIndustryName, setSelectedIndustryName] = useState("");

  const jobsInitialState = {
    category_name: "",
    subcategory_id: "",
    category_icon: "",
    industry_id: "",
  };
  useEffect(() => {
    const fetchIndustries = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL + 'industries/get-all-industries');
        setIndustries(response.data);
        setFilteredIndustries(response.data); 
      } catch (error) {
        console.error('Error fetching industries:', error);
      }
    };

    fetchIndustries();
  }, []);

  const handleIndustrySearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    const filtered = industries.filter((industry) =>
      industry.name.toLowerCase().includes(searchTerm)
    );
    setFilteredIndustries(filtered);
  };
  
  const handleIndustrySelect = (industry, setFieldValue) => {
    setFieldValue("industry_id", industry.id);
    setSelectedIndustryName(industry.name);  
    setShowDropdown(false);
  };

  const navigate = useNavigate();
  const callApiCategoryAdd = async (values) => {
    try {
      console.log("hello........started")
      const url = process.env.REACT_APP_API_URL + "category/addcategory";
      const response = await axios.put(url, values);
      console.log("res.............",response);
      if (response.status === 200) {
        setSuccessMessage("Category added successfully!");
        setShowSuccessModal(true); 
        setTimeout(() => {
          navigate("/categories");
        }, 3000);  
      } else {
        setFailureMessage(response.data.message || "Error adding category.");
        setShowFailureModal(true);
      }
    } catch (error) {
      setFailureMessage("Error adding category. Please try again.");
      setShowFailureModal(true);
    }
  };

  const validateForm = (values) => {
    let errors = {};

    const requiredFields = {
      industry_id: "Industry is required *",
      category_name: "Category name is required *",
      subcategory_id: "SubCategory id is required *",
      category_icon: "Category icon is required*",
    };

    for (const field in requiredFields) {
      if (!values[field]) {
        errors[field] = requiredFields[field];
      }
    }

    return errors;
  };

  const handleSuccessModalClose = async() => {
    setShowModal(false);
    const result = await callApiCategoryAdd(formValues);
    if (result.success) {
      setShowSuccessModal(true);
      setTimeout(() => {
        navigate("/categories");
      }, 3000);      
    } else {
      setShowFailureModal(true);
    }
  };

  const handleSubmitConfirmation = (values) => {
    setFormValues(values);
    setShowModalmessage("Are you sure you want to add this contact?");
    setShowModal(true);
  };
  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Create New Category</h4>
            </Card.Header>
            <Card.Body>
              <Formik
                enableReinitialize={true}
                initialValues={jobsInitialState}
                validate={validateForm}
                onSubmit={(values) => {
                  console.log(values);
                  handleSubmitConfirmation(values);
                }}
              >
                {({ setFieldValue, values }) => (
                  <Form>
                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="industry_id" className="form-label">
                          Industry:
                        </label>
                        <div className="dropdown">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Select Industry"
                            value={selectedIndustryName}
                            onChange={(e) => {
                              handleIndustrySearch(e);
                              setSelectedIndustryName(e.target.value); 
                              setShowDropdown(true);
                            }}
                          />
                          {showDropdown && (
                            <div className="dropdown-menu show" style={{ width: '100%' }}>
                              {filteredIndustries.map((industry) => (
                                <button
                                  key={industry.id}
                                  type="button"
                                  className="dropdown-item"
                                  onClick={() => handleIndustrySelect(industry, setFieldValue)}
                                >
                                  {industry.name}
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
                        <ErrorMessage
                          name="industry_id"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="category_name" className="form-label">
                        Category Name:
                        </label>
                        <Field
                          name="category_name"
                          type="text"
                          className="form-control"
                          placeholder="Enter Category Name"
                        />
                        <ErrorMessage
                          name="category_name"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="subcategory_id" className="form-label">
                        SubCategory ID:
                        </label>
                        <Field
                          name="subcategory_id"
                          type="text"
                          className="form-control"
                          placeholder="Enter SubCategory ID"
                        />
                        <ErrorMessage
                          name="subcategory_id"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="category_icon" className="form-label">
                        Category Icon:
                        </label>
                        <Field
                          name="category_icon"
                          type="text"
                          className="form-control"
                          placeholder="Enter text"
                        />
                        <ErrorMessage
                          name="category_icon"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col className="text-center">
                        <Button type="submit" variant="primary">
                          Create Category Job
                        </Button>
                        <Button
                          type="button"
                          variant="danger"
                          className="mx-2"
                          onClick={() => navigate("/categories")}
                        >
                          Go Back
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <ConfirmationModal
        show={showmodal}
        onHide={() => setShowModal(false)}
        modalMessage={showModalmessage}
        operationType="Confirm"
        confirmation={handleSuccessModalClose}
      />

        <NewconfirmationModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        modalMessage={successMessage}
        operationType="OK"
        timeoutDuration={3000}
      />

      <AllFailureModal
        show={showFailureModal}
        onHide={() => setShowFailureModal(false)}
        modalMessage={failureMessage}
        operationType="OK"
        timeoutDuration={3000}
      />
    </Container>
  );
};

export default AddCategory;